import React from 'react';

const fontStyles: any = {
  label: {
    fontSize: 20,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.25px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 0.15,
  },
};

export interface ITypographyProps {
  variant: 'label' | 'subtitle1';
  style?: any;
  children: any;
}

const Typography = (props: ITypographyProps) => {
  const { variant, children, style } = props;

  return <div style={{ ...fontStyles[variant], ...style }}>{children}</div>;
};

export default Typography;
